var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechRoleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4465 10.0656C10.9659 10.6506 10.9659 11.5956 11.4465 12.1806L16.2277 18.0006L11.4465 23.8206C10.9659 24.4056 10.9659 25.3506 11.4465 25.9356C11.9271 26.5206 12.7034 26.5206 13.184 25.9356L18.8401 19.0506C19.3206 18.4656 19.3206 17.5206 18.8401 16.9356L13.184 10.0506C12.7157 9.48064 11.9271 9.48064 11.4465 10.0656Z",
    fill: "#6B2C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3684 10.0656C18.8878 10.6506 18.8878 11.5956 19.3684 12.1806L24.1495 18.0006L19.3684 23.8206C18.8878 24.4056 18.8878 25.3506 19.3684 25.9356C19.849 26.5206 20.6253 26.5206 21.1059 25.9356L26.7619 19.0506C27.2425 18.4656 27.2425 17.5206 26.7619 16.9356L21.1059 10.0506C20.6376 9.48064 19.849 9.48064 19.3684 10.0656Z",
    fill: "#6B2C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechRoleArrow);
export default __webpack_public_path__ + "static/media/TechRoleArrow.4227d296794cccd9b1107c3c6652adbd.svg";
export { ForwardRef as ReactComponent };